import { RequestTypeValueEnum } from '@app/generated-api';

// group naming must match Medpace.PCS.Business.v2.Models.LiveNotifications.NotificationGroup.ToString() exactly
export const REQUEST_SET_GROUP = 'requestset';

export function buildRequestSetGroup(studyId: number): string {
    return `${REQUEST_SET_GROUP}-${studyId}`;
}

export function buildRequestGroup(type: RequestTypeValueEnum, id: number): string {
    return `${type.toLowerCase()}request-${id}`;
}
